<template>
  <van-popup v-model="showBind" class="backRect" @closed="onClosed">
    <TopBar :pagetitle="title" :is-left-self="true" @leftClick="onBack" />
    <div class="inputRect">
      <van-field
        v-model="postData.lastName"
        clearable
        required
        label="英文姓"
        placeholder="请输入英文姓"
      />
      <van-field
        v-model="postData.firstName"
        clearable
        required
        label="英文名"
        placeholder="请输入英文名"
      />
      <van-field
        v-model="birthday"
        label="生日"
        required
        readonly
        placeholder="请选择生日"
        @click="showDateSelect=true"
      />
      <FieldSelect v-model="sex" :list="sexList" label="性别" placeholder="请选择性别" @change="onSexChange" />
      <FieldSelect v-model="postData.countryId" :list="countryList" label="国家" placeholder="请选择国家" style="border-bottom:1px solid #ebedf0;" />
      <van-field
        v-model="postData.city"
        clearable
        required
        label="城市"
        placeholder="请输入城市"
      />
      <van-field
        v-model="postData.address"
        clearable
        required
        label="地址"
        placeholder="请输入地址"
      />
      <van-field
        v-model="postData.postCode"
        clearable
        required
        label="邮编"
        placeholder="请输入邮编"
      />

      <van-field
        v-model="postData.phone"
        clearable
        required
        label="手机"
        placeholder="请输入手机号码"
      />
      <van-field
        v-model="postData.emergencyContact"
        clearable
        required
        label="紧急联络人"
        placeholder="请输入紧急联络人电话号码"
      />
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>自动确定</span></div>
        <div class="van-cell__value"><van-checkbox v-model="postData.autoConfim" :checked-color="GetColorMain()">自动确认课程绑定</van-checkbox></div>
      </div>
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>自动完成</span></div>
        <div class="van-cell__value"><van-checkbox v-model="postData.autoFinish" disabled :checked-color="GetColorMain()">自动标记课程完成</van-checkbox></div>
      </div>

      <div class="buttonRect">
        <van-button type="primary" size="large" :loading="buttonLoading" :color="GetColorMain()" @click="onAddClass">注册学员账号</van-button>
      </div>
    </div>
    <div v-if="showType==='reg'" class="regAbout">
      以上信息用户均可自行登录AIda网站修改.
    </div>
    <dateSelect v-model="showDateSelect" :default-date="birthday" @onChange="onDateSelect" />
  </van-popup>

</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { Button, Popup, Field, Toast, Checkbox } from 'vant'
import { formatDate, MyNotify, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import { getAidaConfig } from '@/utils/baseData'
import FieldSelect from '@/components/FieldSelect'
import dateSelect from '@/components/dateSelect'
export default {
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Checkbox.name]: Checkbox,
    TopBar,
    FieldSelect,
    dateSelect
  },
  props: {
    // eslint-disable-next-line
    value:undefined,
    // eslint-disable-next-line
    showType:undefined
  },
  data() {
    return {
      title: '注册学员',
      studentId: undefined,
      showBind: false,
      buttonLoading: false,
      postData: {
        firstName: '',
        lastName: '',
        address: '',
        city: '',
        countryId: '',
        postCode: '',
        birthday: undefined,
        phone: '',
        gender: undefined,
        emergencyContact: '',
        autoConfim: true,
        autoFinish: false
      },
      birthday: undefined,
      showDateSelect: false,
      sexList: [],
      sex: undefined,
      countryList: []
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.studentId = newValue
        this.showBind = true
        this.init()
      } else {
        this.showBind = false
        this.studentId = undefined
      }
    }
  },
  created() {

  },
  methods: {
    formatDate,
    MyNotify,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    init() {
      setTimeout(() => {
        getAidaConfig((data) => {
          this.sexList = []
          this.sexList.push({ text: '男性', value: 'MALE' })
          this.sexList.push({ text: '女性', value: 'FEMALE' })
          this.countryList = []
          data.countryList.forEach(item => {
            this.countryList.push({ text: item.k, value: item.v })
          })
          this.postData.countryId = '45'
        })
      }, 1)
    },
    onClosed() {
      this.$emit('input', false)
    },
    onBack() {
      this.showBind = false
      return true
    },
    onAddClass() {
      this.buttonLoading = true
      this.postData.studentId = this.studentId
      request({
        url: '/Pro/regStudentAida',
        method: 'post',
        data: this.postData
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        this.$emit('reload')
        MyNotify('success', '注册成功')
        this.showBind = false
      })
    },
    onSexChange(select) {
      this.postData.gender = select.value
    },
    onDateSelect(date) {
      console.log('onDateSelect', date)
      this.postData.birthday = date
      if (date) {
        this.birthday = formatDate(date, 'yyyy/MM/dd')
      } else {
        this.birthday = undefined
      }
    }
  }
}
</script>
<style scoped>
.backRect{
    width: 100vw;
    height: 100vh;
    background-color: #F1f1f1;
}
.inputRect{
  margin: 1em 1em 0 1em;
  background-color: #fff;
  border-radius: 0.5em;
  overflow: hidden;
}
.regAbout{
  margin:1em 2em;
  color: #999;
  font-size: 0.8em;
}
</style>
